export type PageLayoutMetrics = {
  heights: number[]
  tops: number[]
  totalHeight: number
}

export function buildPageLayoutMetrics(
  totalPages: number,
  getPageHeight: (page: number) => number,
  pageGap: number
): PageLayoutMetrics {
  const heights: number[] = []
  const tops: number[] = []
  let nextTop = 0

  for (let page = 1; page <= totalPages; page++) {
    tops.push(nextTop)
    const height = getPageHeight(page)
    heights.push(height)
    nextTop += height + pageGap
  }

  return {
    heights,
    tops,
    totalHeight: totalPages > 0 ? nextTop - pageGap : 0,
  }
}
